const i18n = {
    zh: {
        relic: '宝物',
        fish: '鱼',
        hero: '英雄',
        common: '普通',
        rare: '稀有',
        epic: '史诗',
        legendary: '传说',
        rarity: '稀有度',
        buildType: '构筑类型',
        effect: '效果',
        combineable: '可合成',
        canCombineInto: '衍生卡牌',
        others: '其他',
        noFilters: '暂无筛选条件',
    },
    'zh-TW': {
        relic: '寶物',
        fish: '魚',
        hero: '英雄',
        common: '普通',
        rare: '稀有',
        epic: '史詩',
        legendary: '傳說',
        rarity: '稀有度',
        buildType: '構築類型',
        effect: '效果',
        combineable: '可合成',
        canCombineInto: '衍生卡牌',
        others: '其他',
        noFilters: '暫無篩選條件',
    },
    en: {
        relic: 'Relic',
        fish: 'Fish',
        hero: 'Hero',
        common: 'Common',
        rare: 'Rare',
        epic: 'Epic',
        legendary: 'Legendary',
        rarity: 'Rarity',
        buildType: 'Build Type',
        effect: 'Effect',
        combineable: 'Combineable',
        canCombineInto: 'Can combine into',
        others: 'Others',
        noFilters: 'No filters available',
    },
    ko: {
        relic: '보물',
        fish: '물고기',
        hero: '영웅',
        common: '일반',
        rare: '희귀',
        epic: '에픽',
        legendary: '전설',
        rarity: '희귀도',
        buildType: '구성 유형',
        effect: '효과',
        combineable: '합성 가능',
        canCombineInto: '파생 카드',
        others: '기타',
        noFilters: '사용 가능한 필터 없음',
    },
    ja: {
        relic: '宝物',
        fish: '魚',
        hero: 'ヒーロー',
        common: 'ノーマル',
        rare: 'レア',
        epic: 'エピック',
        legendary: 'レジェンド',
        rarity: 'レアリティ',
        buildType: 'ビルドタイプ',
        effect: '効果',
        combineable: '合成可能',
        canCombineInto: '派生カード',
        others: 'その他',
        noFilters: 'ソート条件なし',
    },
    th: {
        relic: 'สมบัติ',
        fish: 'ปลา',
        hero: 'ฮีโร่',
        common: 'ทั่วไป',
        rare: 'หายาก',
        epic: 'มหากาพย์',
        legendary: 'ตำนาน',
        rarity: 'ความหายาก',
        buildType: 'สิ่งก่อสร้าง',
        effect: 'เอฟเฟกต์',
        combineable: 'ผสมได้',
        canCombineInto: 'การ์ดอนุพันธ์',
        others: 'อื่น ๆ',
        noFilters: 'ไม่มีการกรอง',
    },
    vi: {
        relic: 'Bảo Vật',
        fish: 'Cá',
        hero: 'Anh Hùng',
        common: 'Thường',
        rare: 'Hiếm',
        epic: 'Sử Thi',
        legendary: 'Truyền Thuyết',
        rarity: 'Độ Hiếm',
        buildType: 'Loại cấu trúc',
        effect: 'Hiệu ứng',
        combineable: 'Được ghép',
        canCombineInto: 'Thẻ Bài Diễn Sinh',
        others: 'Khác',
        noFilters: 'Chưa có điều kiện chọn lọc',
    },
    de: {
        relic: 'Relikt',
        fish: 'Fisch',
        hero: 'Held',
        common: 'Gewöhnlich',
        rare: 'Selten',
        epic: 'Episch',
        legendary: 'Legendär',
        rarity: 'Seltenheit',
        buildType: 'Build-Typ',
        effect: 'Effekt',
        combineable: 'Kombinierbar',
        canCombineInto: 'Kann kombiniert werden zu',
        others: 'Sonstiges',
        noFilters: 'Keine Filter verfügbar',
    },
    fr: {
        relic: 'Relique',
        fish: 'Poisson',
        hero: 'Héros',
        common: 'Commun',
        rare: 'Rare',
        epic: 'Épique',
        legendary: 'Légendaire',
        rarity: 'Rareté',
        buildType: 'Type de configuration',
        effect: 'Effet',
        combineable: 'Combinable',
        canCombineInto: 'Peut être combiné avec',
        others: 'Autres',
        noFilters: 'Aucun filtre disponible',
    },
    es: {
        relic: 'Reliquia',
        fish: 'Pez',
        hero: 'Héroe',
        common: 'Común',
        rare: 'Raro',
        epic: 'Épico',
        legendary: 'Legendario',
        rarity: 'Rareza',
        buildType: 'Tipo de creación',
        effect: 'Efecto',
        combineable: 'Combinable',
        canCombineInto: 'Se puede combinar en',
        others: 'Otros',
        noFilters: 'No hay filtros disponibles',
    },
    pt: {
        relic: 'Relíquia',
        fish: 'Peixe',
        hero: 'Herói',
        common: 'Comum',
        rare: 'Raro',
        epic: 'Épico',
        legendary: 'Lendário',
        rarity: 'Raridade',
        buildType: 'Tipo de Instalação',
        effect: 'Efeito',
        combineable: 'Combinável',
        canCombineInto: 'Pode ser combinado',
        others: 'Outros',
        noFilters: 'Nenhum filtro disponível',
    },
    ru: {
        relic: 'Реликвии',
        fish: 'Рыба',
        hero: 'Герои',
        common: 'Обычн.',
        rare: 'Редк.',
        epic: 'Эпич.',
        legendary: 'Легенд.',
        rarity: 'Редкость',
        buildType: 'Билд',
        effect: 'Эффект',
        combineable: 'Доступен синтез',
        canCombineInto: 'Можно синтезировать',
        others: 'Другое',
        noFilters: 'Нет доступных фильтров',
    },
    it: {
        relic: 'Reliquia',
        fish: 'Pesce',
        hero: 'Eroe',
        common: 'Comune',
        rare: 'Rara',
        epic: 'Epica',
        legendary: 'Leggendaria',
        rarity: 'Rarità',
        buildType: 'Composizione',
        effect: 'Effetto',
        combineable: 'Combinabile',
        canCombineInto: 'Risultato combinazione',
        others: 'Altro',
        noFilters: 'Nessun filtro disponibile',
    },
    id: {
        relic: 'Relik',
        fish: 'Ikan',
        hero: 'Hero',
        common: 'Biasa',
        rare: 'Langka',
        epic: 'Epik',
        legendary: 'Legendaris',
        rarity: 'Kelangkaan',
        buildType: 'Jenis Build',
        effect: 'Efek',
        combineable: 'Bisa digabung',
        canCombineInto: 'Hasil gabungan',
        others: 'Lainnya',
        noFilters: 'Tidak ada filter',
    },
    ar: {
        relic: 'قطعة أثرية',
        fish: 'سمكة',
        hero: 'بطل',
        common: 'شائع',
        rare: 'نادر',
        epic: 'ملحمي',
        legendary: 'أسطوري',
        rarity: 'الندرة',
        buildType: 'نوع البناء',
        effect: 'التأثير',
        combineable: 'قابل للدمج',
        canCombineInto: 'يمكن دمجه مع',
        others: 'أخر',
        noFilters: 'لا توجد فلاتر متاحة',
    },
    tr: {
        relic: 'Yâdigar',
        fish: 'Balık',
        hero: 'Kahraman',
        common: 'Yaygın',
        rare: 'Ender',
        epic: 'Nadir',
        legendary: 'Efsanevi',
        rarity: 'Nadirlik',
        buildType: 'İnşa Türü',
        effect: 'Etki',
        combineable: 'Birleştirilebilir',
        canCombineInto: 'Birleştirme Uygunluğu',
        others: 'Diğerleri',
        noFilters: 'Uygun bir filtre yok',
    },
};

module.exports = { i18n };



// WEBPACK FOOTER //
// ./src/tool/i18n.js